import styled from "styled-components";
import { Spin } from "antd";
import InlineSvg from "react-inlinesvg";
import { icons } from "@constants/icons";
import { useTranslation } from "react-i18next";
import ModalCommon from "./ModalCommon";

type Props = {
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
  loading?: boolean;
  text?: string;
  btnCancelText?: string;
  btnComfirmText?: string;
};

const ModalConfirmCancel = ({
  visible,
  onOk,
  onCancel,
  loading = false,
  text = "Modal:form.cancel.title",
  btnCancelText = "Home:btn.back",
  btnComfirmText = "Home:confirm",
}: Props) => {
  const [t] = useTranslation();
  return (
    <Contents id="modal-confirm-cancel">
      <ModalCommon
        visible={visible}
        onOk={onOk}
        onCancel={onCancel}
        loading={loading}
        btnCancelText={btnCancelText}
        btnComfirmText={btnComfirmText}
      >
        {!loading && (
          <>
            <InlineSvg src={icons.cancel_error} />
            <div className="text">{t(text)}</div>
          </>
        )}
        {loading && <Spin size="large" />}
      </ModalCommon>
    </Contents>
  );
};

export default ModalConfirmCancel;

const Contents = styled.div`
  .ant-modal {
    top: 15px;
    width: 480px;
  }
  .ant-modal-content {
    box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 50%);
    border-radius: 0.3rem;
  }
  .ant-modal-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 0 0 0.3rem 0.3rem;
    padding: 18px 24px;
    .ant-btn-text {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 120px;
      :hover {
        opacity: 1;
      }
    }
    .ant-btn-text[disabled],
    .ant-btn-text[disabled]:active,
    .ant-btn-text[disabled]:focus,
    .ant-btn-text[disabled]:hover {
      color: rgba(0, 0, 0, 0.25);
      > svg > path {
        stroke: rgba(0, 0, 0, 0.25);
        fill: rgba(0, 0, 0, 0.25);
      }
    }
    .footer-save {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #e02020;
      border-color: #e02020;
      width: 33%;
      &.ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):hover {
        background: #e02020;
        opacity: 0.8;
      }
    }
  }
  .ant-modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .text {
    font-size: 22px;
    margin: 5px 0;
  }
`;
